import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdChevronRight } from 'react-icons/md';

import {
  Container, Content,
  InfoContainer,
  Title, Info, ItemButton, IconContainer,
} from './styles';
import BackArrow from '../../components/BackArrow';

export default function ChallengesList() {
  const navigate = useNavigate();

  return (
    <Container>
      <BackArrow text="Desafios" bigger backTo="/club" />
      <Content>
        <ItemButton onClick={() => navigate('/club/desafios/')}>
          <InfoContainer>
            <Title>Desafios</Title>
            <Info>
              Escolha a corrida e a distância, corra de onde estiver, dentro das datas estipuladas, e receba o kit especial em seu endereço.
            </Info>
          </InfoContainer>
          <IconContainer>
            <MdChevronRight size={50} color="white" />
          </IconContainer>
        </ItemButton>

        <ItemButton onClick={() => navigate('/club/corrida-virtual')}>
          <InfoContainer>
            <Title>Corridas Virtuais</Title>
            <Info>
              Participe de desafios virtuais de distância acumulada em várias atividades. O prazo você quem define. Ao final, uma medalha especial em seu endereço.
            </Info>
          </InfoContainer>
          <IconContainer>
            <MdChevronRight size={50} color="white" />
          </IconContainer>
        </ItemButton>
      </Content>
    </Container>
  );
}
